var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "goods-detail" },
    [
      _c(
        "el-form",
        _vm._b(
          { ref: "formRef", attrs: { model: _vm.form } },
          "el-form",
          _vm.formConfig,
          false
        ),
        [
          _c(
            "el-form-item",
            { attrs: { label: "商品详情：" } },
            [
              _c("el-alert", {
                staticClass: "image-upload-tip",
                attrs: {
                  closable: false,
                  title: "建议上传分辨率为750×高度随机的图片，大小≤5MB",
                  type: "warning",
                  "show-icon": "",
                },
              }),
              _vm._v(" "),
              _c("Tinymce", {
                staticClass: "editer",
                attrs: { sourceType: "spu" },
                model: {
                  value: _vm.form.content,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "content", $$v)
                  },
                  expression: "form.content",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "购买须知：" } },
            [
              _c("Tinymce", {
                attrs: { height: 200, toolbar: _vm.tinymceToolbar },
                model: {
                  value: _vm.form.purchaseNotice,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "purchaseNotice", $$v)
                  },
                  expression: "form.purchaseNotice",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "使用须知：" } },
            [
              _c("Tinymce", {
                attrs: { height: 200, toolbar: _vm.tinymceToolbar },
                model: {
                  value: _vm.form.useNotice,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "useNotice", $$v)
                  },
                  expression: "form.useNotice",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }